
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcTableHeaderItem as ObcTableHeaderItemElement} from '@oicl/openbridge-webcomponents/dist/components/table-header-item/table-header-item.js';
 
 
 

 
 export const ObcTableHeaderItem = createComponent({
   react: React,
   tagName: 'obc-table-header-item',
   elementClass: ObcTableHeaderItemElement,
   events: {
     
   }
  });
 
 